<bp-sidenav>
	<bp-nav-item path="/merchants"> Merchants </bp-nav-item>

	<bp-nav-item *bpHasAccess="Feature.bridgerPsps" path="/psps"> PSPs </bp-nav-item>
</bp-sidenav>
